import React, { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import { useResume } from '../context/ResumeContext';
import DraftEditor from './common/DraftEditor';
import CalendarIcon from "../assets/images/_calender.svg";
import { ADDITONAL_PREDEFINE_SECTIONS, MONTHS } from '../constants/constants';
import DeleteIcon from '../assets/images-new/icons/bin-icon.svg';
import { usePopup } from '../context/PopupContext';
import { formatDate, rbDate2String } from '../helper';
import GPTSuggestionPopup from './common/GPTSuggestionPopup';
import PhrasesPopup from './common/PhrasesPopup';
import { removeBodyScroll } from '../helper';
const CustomSection = (props) => {
//console.log(props);

  const {
    resume,
    handlers: {
      updateResumePreview,
    },
  } = useResume();
  const sec_id = props?.sec
  const section = resume[sec_id]
  const confirmbox = usePopup();
  let grid = section.hasOwnProperty('grid') ? section.grid : {};
  const emptyrow = ADDITONAL_PREDEFINE_SECTIONS.additional_information.struct.grid.row_1
  const [showAIPopup, setShowAIPopup] = useState(false);
  const [showPhrasePopUp, setShowPhrasePopUp] = useState(false);
  const [checkField, setCheckField] = useState('');
  useEffect(() => {
    if (!section.hasOwnProperty('grid')) {
      let struct = { ...emptyrow };
      struct.content = section.content;
      updateResumePreview({ [sec_id]: { ...section, grid: { row_1: { ...struct } } } });
    }

  }, []);
  const updateRow = (input, id) => {
    const row = {
      [id]: {//example certifications_1
        ...grid[id],
        ...input
      }
    }
    updateResumePreview(
      { [sec_id]: { ...section, grid: { ...grid, ...row } }, current_tab: 'additional_sections',  }
    )
  }
  const addRow = (newname = '') => {
    const id = 'row_' + Math.floor(Math.random() * 1000)
    const row = { ...emptyrow }
    /**
     * START
     * Changes to close automatically the previously opened tabs on adding a new one
     * Ticket: https://gitlab.dailyrssmail.com/growthlabs/resumebuilder-app/-/issues/530
     * Date: 2024-01-05
     */
    grid = Object.keys(grid).map(key => {
      return {...grid[key], open: false}
    })
    /**
     * END
     */
    updateResumePreview(
      { [sec_id]: { ...section, grid: { ...grid, [id]: { ...row } } }, current_tab: 'additional_sections',  }
    )
  }
  const deleteRow = (id) => {
    if (grid.hasOwnProperty(id)) {
      let t = { ...grid }
      delete t[id]
      if (!Object.keys(t).length) {//Last need to handle with default settings
        const newid = 'row_' + Math.floor(Math.random() * 1000)
        t = { [newid]: { ...emptyrow } }
      }
      updateResumePreview({ [sec_id]: { ...section, grid: { ...t } }, current_tab: 'additional_sections' })
    }
  }
  const fieldFocus = (e, id) => {
    setCheckField(e.target.name + '-' + id)
  }
  const fieldBlur = (e, id) => {
    setCheckField('');
  }
  const TabStatus = props => <div className="arrow-action" onClick={props.onClick}> {props.t ? <i className="icon-chevron-left"></i> : <i className="icon-right-arrow"></i>}</div>;
  return (<div className="editor-form accomplishments-blocks">
    {Object.keys(grid).map((id) => (
      <div className="sub-list-wrap" key={id}>
        <div className="sub-list" onClick={() => (updateRow({ open: !grid[id].open }, id))}>
          <span className="sub-name">{grid[id].name.length ? grid[id].name : 'Name'}</span>
          <div className="controls">
            <div className="delete-action">
              <span onClick={(e) => {confirmbox.show('row_delete', null, () => deleteRow(id)), removeBodyScroll(true)}}>
                <DeleteIcon />
              </span>
            </div>
            <TabStatus t={grid[id].open} onClick={() => (updateRow({ open: !grid[id].open }, id))} />
          </div>
        </div>
        {grid[id].open && <div className="sub-form">
          <div className="form-row">
            <div className="field-wrap">
              {/* <label htmlFor="name" className={`label${checkField == 'name-' + id ? ' label-focus' : ''}`}>Name</label> */}
              <input
                placeholder="Name"
                type="text"
                name="name"
                value={grid[id].name}
                onChange={(e) => {
                  updateRow({ name: e.target.value }, id)
                }}
                onFocus={(e) => fieldFocus(e, id)}
                onBlur={(e) => fieldBlur(e, id)}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="field-wrap">
              {/* <label htmlFor="address" className={`label${checkField == 'address-' + id ? ' label-focus' : ''}`}>Address</label> */}
              <input
                placeholder="Address"
                type="text"
                name="address"
                onChange={(e) => {
                  updateRow({ address: e.target.value }, id)
                  //e.target.value
                }}
                value={grid[id].address}
                onFocus={(e) => fieldFocus(e, id)}
                onBlur={(e) => fieldBlur(e, id)}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="field-wrap">
              {/* <label htmlFor="address_line_2" className={`label${checkField == 'address_line_2-' + id ? ' label-focus' : ''}`}>Address Line 2</label> */}
              <input
                placeholder="Address Line 2"
                type="text"
                name="address_line_2"
                onChange={(e) => {
                  updateRow({ address_line_2: e.target.value }, id)
                  //e.target.value
                }}
                value={grid[id].address_line_2}
                onFocus={(e) => fieldFocus(e, id)}
                onBlur={(e) => fieldBlur(e, id)}
              />
            </div>
          </div>
          <div className="form-row column-2">
            <div className="field-wrap date-field">
              {/* <label htmlFor="start_date" className={`label${checkField == 'awarded_date-' + id ? ' label-focus' : ''}`}>Start Date</label> */}
              <DatePicker
                showMonthYearPicker
                //value={}
                placeholderText="Start Date"
                value={formatDate(grid[id].start_date)}
                selected={formatDate(grid[id].start_date)}
                name="awarded_date"
                className="form-input borderaccent custom-date-picker"
                dateFormat="MMMM yyyy"
                disabled={false}
                autoComplete="off"
                onChange={e => updateRow({ start_date: rbDate2String(e.getMonth(), e.getFullYear()) }, id)}
                onChangeRaw={e => e.preventDefault()}
                onFocus={(e) => fieldFocus(e, id)}
                onBlur={(e) => fieldBlur(e, id)}
              />
            </div>
            <div className="field-wrap date-field">
              {/* <label htmlFor="end_date" className={`label${checkField == 'awarded_date-' + id ? ' label-focus' : ''}`}>End Date</label> */}
              <DatePicker
                showMonthYearPicker
                //value={}
                placeholderText="End Date"
                value={formatDate(grid[id].end_date)}
                selected={formatDate(grid[id].end_date)}
                name="awarded_date"
                className="form-input borderaccent custom-date-picker"
                dateFormat="MMMM yyyy"
                disabled={false}
                autoComplete="off"
                onChange={e => updateRow({ end_date: rbDate2String(e.getMonth(), e.getFullYear()) }, id)}
                onChangeRaw={e => e.preventDefault()}
                onFocus={(e) => fieldFocus(e, id)}
                onBlur={(e) => fieldBlur(e, id)}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="field-wrap">
              <label htmlFor="description" className="label editor-label">Summary</label>
              <DraftEditor
                name="description"
                // placeholder="e.g. Passionate science teacher with 8+ years of experience and a track record of..."
                className="validate"
                value={grid[id].content}
                onInputChange={val => updateRow({ content: val }, id)}
                chatGptButton={false}
                phrasesButton={false}
                colorType="orange"
                showAIPopup={showAIPopup}
                setShowAIPopup={(showAIPopup) => { setShowAIPopup(showAIPopup) }}
                showPhrasePopUp={showPhrasePopUp}
                setShowPhrasePopUp={(showPhrasePopUp) => { setShowPhrasePopUp(showPhrasePopUp) }}
              />
              {/* {(showAIPopup 
              ? <GPTSuggestionPopup 
                section="custom"
                phrase=""
                id={id}
                data={grid[id]}
                updateAction={updateRow}
                setShowAIPopup={(a) => setShowAIPopup(a)}
              /> 
              : emptyAiData())}
              {showPhrasePopUp 
              ? <PhrasesPopup 
                  section='custom'
                  phrase=""
                  id={props.id}
                  data={job}
                  updateAction={props.updateJob}
                  setShowPhrasePopUp={(s) => setShowPhrasePopUp(s)}
                /> : ''} */}
            </div>
          </div>
        </div>}
      </div>))}
    <div className="add-more-wrap">
      <span
        className="add-more-skills"
        onClick={(e) => {
          addRow()
        }}>
        <i className="icon-plus-icon"></i> Add one more
      </span>
    </div>
  </div>);
}

export default CustomSection;